import React, { Component } from 'react'
import DataQueryForm from './DataQueryForm.tsx'

import s from './style.scss'

/**
 * TODO: Docs
 * This wrapper functions mainly as error boundary
 */
class DataQuery extends Component {

    constructor(props) {
        super(props)
        this.state = { hasError: false }
      }

    componentDidCatch(error, info) {
        this.setState({ hasError: true })
        // TODO: maybe log somewhere
    }

    render() {
        if (this.state.hasError) {
            // headline is set outside react <h1 style={{display: 'block', marginBottom: '0.5em'}}>Advanced access</h1>
            return <React.Fragment>
                { window.navigator.userAgent.indexOf('Trident') !== -1
                    ?   <div className={s.error}>
                            Older versions of Internet Explorer are not supported by this interface.
                            Please update to IE 11 or Microsoft Edge or use another browser.
                        </div>
                    :   <div className={s.error}>
                            <p><strong>An unexpected error occurred.</strong></p> 
                            <p>You can:</p>
                            <ul>
                                <li>Make sure to use an up-to-date browser.</li>
                                <li>Reload this page.</li>
                                <li>Report the error to meteoblue.</li>
                            </ul>
                        </div>
                }
            </React.Fragment>
        } else {
            return <DataQueryForm />
        }
    }




}

export default DataQuery